import PropTypes from 'prop-types';

import classNames from 'classnames';

import Collapsible from '../Collapsible';

import CollapsibleIcon from '../icons/CollapsibleIcon/CollapsibleIcon';

import Colors from '../utils/colors';

import styles from './FAQAccordion.module.scss';

const themes = {
  legacy: 'legacy',
  homepage: 'homepage',
  'how-it-works': 'how-it-works'
};

const getCollapsibleIcons = theme => {
  switch (theme) {
    case themes.homepage:
      return {
        iconClosed: (
          <span className={styles['faq-accordion-item__icon']}>+</span>
        ),
        iconOpened: (
          <span className={styles['faq-accordion-item__icon']}>-</span>
        )
      };
    case themes['how-it-works']:
      return {
        iconClosed: <CollapsibleIcon collapsed color={Colors.white} />,
        iconOpened: <CollapsibleIcon />
      };
    case themes.legacy:
    default:
      return {};
  }
};

const FAQAccordionItem = ({
  top,
  content,
  isOpened = false,
  theme = 'legacy',
  onCollapsedChange = () => {}
}) => {
  const isNotLegacy = theme !== 'legacy';

  const itemCN = classNames(styles['faq-accordion-item'], {
    [styles[`faq-accordion-item--${theme}`]]: isNotLegacy
  });
  const topCN = classNames(styles['faq-accordion-item__top'], {
    [styles[`faq-accordion-item__top--${theme}`]]: isNotLegacy
  });

  const contentCN = classNames(styles['faq-accordion-item__content'], {
    [styles[`faq-accordion-item__content--${theme}`]]: isNotLegacy
  });

  const headerClassName = classNames(styles['faq-accordion-item__header']);

  return (
    <div className={itemCN}>
      <Collapsible
        headerClassName={headerClassName}
        renderHeader={() => <h4 className={topCN}>{top}</h4>}
        renderBody={() => (
          <div
            className={contentCN}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
        hasIcon
        isCollapsed={!isOpened}
        onCollapsedChange={onCollapsedChange}
        {...getCollapsibleIcons(theme)}
      />
    </div>
  );
};

FAQAccordionItem.themes = themes;
FAQAccordionItem.propTypes = {
  top: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  isOpened: PropTypes.bool,
  theme: PropTypes.oneOf(['legacy', 'homepage', 'how-it-works']),
  onCollapsedChange: PropTypes.func
};

export default FAQAccordionItem;
